import React from 'react';
import { Global, css } from '@emotion/core';
import normalizeCss from 'emotion-normalize';

function GlobalCss({ fontFamily }) {
    /* yahoo tracking 會在 body 下插入一個 img 元素來發請求，但會導致 body 高度變化，
       在 iframe embed 的情況下會導致高度不精確
    */
    const yahooTrackingCssBug = `
        body > img[src*="sp.analytics.yahoo.com"] {
            position: absolute;
            bottom: 0;
        }
    `;
    return (
        <Global
            styles={css`
                ${normalizeCss}
                html, body, #root {
                    height: 100%;
                }
                body {
                    font-family: ${fontFamily};
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                    letter-spacing: 0.1em;
                }

                ${yahooTrackingCssBug}

                // scrollbar custom css
                .trackYVisible {
                    .ScrollbarsCustom-Wrapper {
                        right: 0px !important;
                    }
                }

                .ScrollbarsCustom-Track {
                    background: #f8f8f8 !important;
                    border-radius: 4px !important;
                }

                .ScrollbarsCustom-Thumb {
                    background: #ccc !important;
                    border-radius: 4px !important;
                    &:hover {
                        background: #9b9b9b !important;
                    }
                }

                /* Mui Global Css */
                .MuiButtonBase-root.Mui-disabled,
                .MuiSelect-select.Mui-disabled,
                .MuiInputBase-input.Mui-disabled {
                    cursor: not-allowed;
                }
                .MuiButtonBase-root.Mui-disabled {
                    pointer-events: initial;
                }
                .MuiTooltip-tooltip {
                    padding: 8px;
                    color: #fff;
                    background-color: #000;
                    & .MuiTooltip-arrow {
                        color: #000;
                    }
                }
            `}
        />
    );
}

export default GlobalCss;
